import { loadManifest } from '@angular-architects/module-federation';

const skipRemoteEntries = false;

console.info('💎 Loading Manifest 💎');

loadManifest('/assets/config/module-federation.manifest.json', skipRemoteEntries)
  .catch((err) => console.error('🛑 Error loading manifest', err))
  .then((x) => import('./bootstrap'))
  .catch((err) => console.error('🛑 Error loading bootstrap', err));
